import {HeaderMall9} from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import CallsUsForm from "../../../../publicComponent/CallsUsForm";

function Callus() {
  
  return (
    <div>
      <HeaderMall9/>
      <Navigator title="联系我们"/>
      <CallsUsForm/>
    
    </div>
  );
}

export default Callus;
